import request from "./request";

// Link to Swagger dev API documentation
// https://devapi.primestreet.io/interviews-api/swagger-ui/#/do-not-contact-controller
const dnc = {
  service() {
    return {
      list(params) {
        params.page = !params.page ? 0 : params.page;
        params.size = !params.size ? 10 : params.size;

        return request.get("/interviews-api/opportunities", params);
      },
      search(params) {
        params.page = !params.page ? 0 : params.page;
        params.size = !params.size ? 10 : params.size;

        return request
          .get("/interviews-api/DNC/search", params)
          .then((resp) => {
            console.log("*********************************");
            console.log(resp);
            console.log("*********************************");
            return {
              resp: resp,
              type: params.type,
              value: params.value ? params.value : "",
            };
          })
          .catch((e) => {
            throw e;
          });
      },
      addToDNC(data) {
        return request.post("/interviews-api/DNC", data);
      },
      patchDNC(dncId, data) {
        return request.patch(`/interviews-api/DNC/${dncId}`, data);
      },
      removeFromDNC(params) {
        return request.delete("/interviews-api/DNC/delete", params);
      },
    };
  },
};

export default dnc;
